function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Auth } from 'aws-amplify';
import { createLogic } from 'redux-logic';
import ActionTypes from '../ActionsTypes';

var AuthHelper =
/*#__PURE__*/
function () {
  function AuthHelper() {
    _classCallCheck(this, AuthHelper);
  }

  _createClass(AuthHelper, null, [{
    key: "refreshSessionPromise",
    value: function () {
      var _refreshSessionPromise = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(refreshToken) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee2(resolve, reject) {
                    var user;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return Auth.currentAuthenticatedUser();

                          case 2:
                            user = _context2.sent;
                            return _context2.abrupt("return", user.refreshSession(refreshToken,
                            /*#__PURE__*/
                            function () {
                              var _ref2 = _asyncToGenerator(
                              /*#__PURE__*/
                              regeneratorRuntime.mark(function _callee(err, data) {
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        if (err) reject(err);else {
                                          resolve(data); // THIS IS YOUR REFRESHED ATTRIBUTES/GROUPS
                                        }

                                      case 1:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee, this);
                              }));

                              return function (_x4, _x5) {
                                return _ref2.apply(this, arguments);
                              };
                            }()));

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));

                  return function (_x2, _x3) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function refreshSessionPromise(_x) {
        return _refreshSessionPromise.apply(this, arguments);
      };
    }()
  }, {
    key: "refreshCurrentSession",
    value: function () {
      var _refreshCurrentSession = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var session;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Auth.currentSession();

              case 2:
                session = _context4.sent;
                return _context4.abrupt("return", this.refreshSessionPromise(session.getRefreshToken()));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function refreshCurrentSession() {
        return _refreshCurrentSession.apply(this, arguments);
      };
    }()
  }]);

  return AuthHelper;
}();

var get =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(url, id, saveData, pathname, history) {
    var dat;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            dat = new Promise(
            /*#__PURE__*/
            function () {
              var _ref4 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee5(resolve, reject) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.t0 = fetch;
                        _context5.t1 = url;
                        _context5.next = 4;
                        return getApiRequestHeaders();

                      case 4:
                        _context5.t2 = _context5.sent;
                        _context5.t3 = {
                          method: 'GET',
                          mode: 'cors',
                          headers: _context5.t2
                        };

                        _context5.t4 = function (response) {
                          return response.json();
                        };

                        _context5.t5 = function (data) {
                          if (data.error === 'INVALID_REQUEST_TRIAL_EXPIRED') {
                            return history.push('/choose-plan:trial-expired');
                          }

                          if (data.error === 'INVALID_REQUEST_STANDARD_EXPIRED') {
                            return history.push('/choose-plan:standard-expired');
                          }

                          if (data.error === 'INVALID_REQUEST_PREMIUM_EXPIRED') {
                            return history.push('/choose-plan:premium-expired');
                          }

                          resolve(saveData(id, data.data));
                        };

                        _context5.t6 = function (err) {
                          // eslint-disable-next-line no-console
                          console.log(err);
                          reject();
                        };

                        (0, _context5.t0)(_context5.t1, _context5.t3).then(_context5.t4).then(_context5.t5).catch(_context5.t6);

                      case 10:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, this);
              }));

              return function (_x11, _x12) {
                return _ref4.apply(this, arguments);
              };
            }());
            return _context6.abrupt("return", dat);

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function get(_x6, _x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchData = createLogic({
  type: ActionTypes.GET_DATA,
  latest: true,
  process: function (_process) {
    function process(_x13) {
      return _process.apply(this, arguments);
    }

    process.toString = function () {
      return _process.toString();
    };

    return process;
  }(function (_ref5) {
    var action = _ref5.action;

    try {
      var _action$payload = action.payload,
          id = _action$payload.id,
          pathname = _action$payload.pathname,
          saveData = _action$payload.saveData,
          history = _action$payload.history;
      var url = "".concat(process.env.COSMOS_DATA_API_URL).concat(pathname);
      get(url, id, saveData, pathname, history);
    } catch (error) {
      console.log(':(', error); // eslint-disable-line
    }
  })
});

function getApiRequestHeaders() {
  return _getApiRequestHeaders.apply(this, arguments);
}

function _getApiRequestHeaders() {
  _getApiRequestHeaders = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7() {
    var session;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return AuthHelper.refreshCurrentSession();

          case 2:
            _context7.next = 4;
            return Auth.currentSession();

          case 4:
            session = _context7.sent;
            return _context7.abrupt("return", {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              cookies: session.accessToken.jwtToken
            });

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));
  return _getApiRequestHeaders.apply(this, arguments);
}

export default [fetchData];